import { makeid } from 'utils/helpers/makeid';

import type {
  IBooleanOption,
  IFormItemOption,
  IStringBooleanOption,
} from '../types';

export const booleanOptions: IBooleanOption[] = [
  { label: 'Yes', value: true, key: makeid(10) },
  { label: 'No', value: false, key: makeid(10) },
];

export const stringBooleanOptions: IStringBooleanOption[] = [
  { label: 'Yes', value: 'true', key: makeid(10) },
  { label: 'No', value: 'false', key: makeid(10) },
];

export const nursingInterventionOptions: IFormItemOption<string>[] = [
  {
    value: 'emergencyRoom',
    label: 'Emergency room/urgent care/911 assist',
    key: makeid(10),
  },
  {
    value: 'escalation',
    label: 'Escalation to clinic',
    key: makeid(10),
    optionChildren: [
      {
        type: 'checkbox',
        name: 'escalationToClinic',
        options: [
          {
            value: 'escalation1',
            label: 'Symptomatic patient',
            key: makeid(10),
          },
          {
            value: 'escalation2',
            label: 'Patient declining nursing recommendation',
            key: makeid(10),
          },
          {
            value: 'escalation3',
            label: 'Consecutive critical readings without improvement',
            key: makeid(10),
          },
          {
            value: 'escalation4',
            label: 'Reading well outside of their normal range',
            key: makeid(10),
          },
          {
            value: 'escalation5',
            label: 'Concerning trend in readings',
            key: makeid(10),
          },
        ],
        key: makeid(10),
      },
    ],
  },
  {
    value: 'nursingEducation',
    label: 'Nursing education',
    key: makeid(10),
  },
];

export const notEscalatedOptions: IFormItemOption<string>[] = [
  {
    value: 'notEscalatedRepeat',
    label: 'Repeat reading recovered',
    key: makeid(10),
    extraType: 'checkbox',
  },
  {
    value: 'notEscalatedError',
    label: 'Device/User error',
    key: makeid(10),
    extraType: 'checkbox',
  },
  {
    value: 'notEscalatedProtocol',
    label: 'Clinical Instructions',
    key: makeid(10),
    extraType: 'checkbox',
  },
];

export const commonFactors: IFormItemOption<string>[] = [
  {
    label: 'Dietary changes',
    value: 'dietaryChanges',
    key: makeid(10),
  },
  {
    label: 'Physical activity changes',
    value: 'physicalActivityChanges',
    key: makeid(10),
  },
  {
    label: 'Medication non-adherence (Why? Cost, access, etc)',
    value: 'nonAdherence',
    key: makeid(10),
  },
  {
    label: 'Recent illness or infection',
    value: 'recentIllness',
    key: makeid(10),
  },
  {
    label: 'Recent injury/surgery',
    value: 'recentInjury',
    key: makeid(10),
  },
  {
    label: 'Psychosocial distress/stress',
    value: 'stress',
    key: makeid(10),
  },
];
